import { configureStore } from '@reduxjs/toolkit';
import {accountApi} from "./account/account.api";
import accountReducer from './account/account.slice';
import appReducer from './app/app.slice';
import pickXSlice from './pickX/pickX.slice';
import pickXApi from "./pickX/pickX.api";
import tradefanApi from "./tradefan/tradefan.api";
import sportsSlice from "./sports/sports.slice";
import ecommerceSlice from "./ecommerce/ecommerce.slice";

const store = configureStore({
    reducer: {
        app: appReducer,
        account: accountReducer,
        ecommerce: ecommerceSlice,
        [pickXSlice.reducerPath]: pickXSlice.reducer,
        [sportsSlice.reducerPath]: sportsSlice.reducer,
        [accountApi.reducerPath]: accountApi.reducer,
        [pickXApi.reducerPath]: pickXApi.reducer,
        [tradefanApi.reducerPath]: tradefanApi.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat( accountApi.middleware)
            .concat( pickXApi.middleware)
            .concat( tradefanApi.middleware), // Add the API middleware
});

export default store;
